<div class="input-filter-container" *ngIf="availableOptions">
	<div>
		<input
			[ngClass]="{
				disabled: disabled,
				italic: selectedOption?.disabled == true,
				'empty-filter-option': !setValue && (!filteredOptions || (filteredOptions && filteredOptions.length === 0)),
				markAlert: alert,
			}"
			[style]="{ height: inputHeight ? inputHeight : '1.5rem' }"
			[value]="setInputText"
			[placeholder]="placeholder"
			[disabled]="disabled"
			(input)="
				openOptions = true;
				setValue = '';
				lastFilterHover = 0;
				emitIndex(-1);
				setInputText = $event.target.value;
				emitInputText();
				emitValue();
				filterFunction()
			"
			(keydown)="keyboardHandler($event)"
			(click)="openOptions = true"
			(focus)="openOptions = true; inputWithAutoCompleteFocus = true"
			(blur)="
				inputWithAutoCompleteFocus = false;
				lastFilterHover = 0;
				!allowFreeText && setInputText !== '' && setValue === '' ? (alert = true) : null
			"
			#inputWithAutoComplete
			[id]="idGen" />
		<label
			[style]="{ height: inputHeight ? inputHeight : '1.5rem' }"
			[for]="idGen"
			*ngIf="!setValue && filteredOptions && filteredOptions.length > 0 && !disabled">
			<fa-icon [icon]="faAngleDown"></fa-icon>
		</label>

		<label
			[style]="{ height: inputHeight ? inputHeight : '1.5rem' }"
			[for]="inputWithAutoComplete"
			*ngIf="setValue && setInputText && !disabled"
			(click)="removeSelectedOption()"
			(keydown.enter)="removeSelectedOption()">
			<fa-icon [icon]="faTimes"></fa-icon>
		</label>
	</div>
	<div
		[ngClass]="{ inputWithAutoCompleteFocus: inputWithAutoCompleteFocus }"
		[ngStyle]="{ bottom: openTop ? (inputHeight ? inputHeight : '26px') : 'unset' }"
		class="input-filtered-list"
		tabindex="-1"
		*ngIf="openOptions === true && filteredOptions && filteredOptions.length > 0"
		#inputFilteredList>
		<div
			[ngClass]="{ 'last-hover': lastFilterHover === index, italic: option.disabled == true }"
			(mouseenter)="lastFilterHover = index"
			(click)="handleClickOption(option, index)"
			[id]="idGen + '_' + option.value"
			[title]="option.tip ? option.tip : option.name"
			*ngFor="let option of filteredOptions; let index = index">
			<div [ngClass]="{ 'single-value': !option.commonGroup }">
				<span>{{ option.name }}</span>
				<span class="tip"><fa-icon [icon]="faExclamationCircle" *ngIf="option.tip"></fa-icon></span>
			</div>
			<div *ngIf="option.commonGroup">({{ option.commonGroup === '1A' ? 'CMDB' : option.commonGroup }})</div>
		</div>
	</div>
</div>

<div *ngIf="!this.availableOptions">**Available options not defined**</div>
